<template>
  <v-container>
    <v-row>
      <v-col class="d-flex justify-end">
        <c-btn v-if="checkUpdateFlag" class="mx-1" color="blue" outlined iconName="mdi-pencil" @click="save">저장</c-btn>
        <c-btn v-else class="mx-1" color="blue" outlined iconName="mdi-pencil" :disabled="disabledByRole"
               @click="update">수정
        </c-btn>
        <c-btn class="mx-1" color="grey" outlined @click="$router.go(-1)"
               iconName="mdi-format-list-bulleted-square">
          돌아가기
        </c-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0">
        <c-card outlined title="이용 용도 목록">
          <table v-if="checkUpdateFlag">
            <draggable v-model="useList" :options="{handle: '.control-drag'}">
                <tr v-for="(item, idx) in useList" :key="item" >
                  <td class="updateTableCol">
                    <span class="subtitle-2">{{ idx + 1 }}</span>
                  </td>
                  <td>
                    <v-text-field dense v-model="item.value"  :placeholder="item.value" class="ma-0" />
                  </td>
                  <td class="control-drag" style="width: 20px;">
                    <v-icon>drag_indicator</v-icon>
                  </td>
                  <td class="updateTableCol">
                    <v-btn fab x-small color="error" depressed @click="removeUse(idx)">
                      <v-icon>remove</v-icon>
                    </v-btn>
                  </td>
                </tr>
                <tr>
                  <td class="updateTableCol">
                    <span>{{ useList.length + 1 }}</span>
                  </td>
                  <td style="width: 215px">
                    <span class="subtitle-1 font-weight-bold">기타</span>
                  </td>
                  <td></td>
                  <td class="updateTableCol">
                    <v-btn fab x-small color="primary" depressed @click="addUse">
                      <v-icon>add</v-icon>
                    </v-btn>
                  </td>
                </tr>
            </draggable>
          </table>

          <div v-else style="width:700px">
            <c-table
                :headers="tableHeader"
                :items="useList"
                hide-default-footer
                :items-per-page="-1"
            ></c-table>
          </div>

        </c-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import draggable from 'vuedraggable';
export default {
  components: {
    draggable
  },
  data() {
    return {
      tableHeader: [
        {
          text: 'No.',
          value: 'no',
          align: 'center',
          sortable: false
        },
        {
          text: '이용용도',
          value: 'value',
          align: 'center',
          sortable: false
        },
      ],

      useList: [],
      dragging: false,
      useUpdateFlag: false,
      resultList: [],
    }
  },
  mounted() {
    this.reqUseList();
  },
  computed: {
    disabledByRole() {
      return this.$store.state.userInfo.role === 'RM';
    },
    checkUpdateFlag() {
      return (this.useUpdateFlag === true);
    }
  },
  methods: {
    async reqUseList() {
      try {
        const res = await this.$api.getUseList();
        this.useList = res.data.map((item, idx) => {
          return {
            no: idx + 1,
            value: item
          }
        });
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqUseList'});
      }
    },
    removeUse(idx) {
      this.useList.splice(idx, 1);
    },
    addUse() {
      let data = {value: ""};
      this.useList.splice(this.useList.length, 0, data);
    },
    update() {
      this.useUpdateFlag = true;
      this.useList.pop(); // '기타' 잘라줌
    },
    save() {
     let result = true;

     for (let item of this.useList) {
       if (!item.value) {
         this.$store.commit('snackbar', {msg: '비어있는 필드가 있습니다.'});
         result = false;
       }
     }

      if (result) {
        this.$store.commit('alert',
            {
              open: true, persistent: true, msg: "변경 사항을 저장하시겠습니까?",
              confirm: true, callBack: () => {
                const useListString = this.useList.map(item => item.value).join().concat(",기타"); // 문자열 형태로 만들어줌
                const reqData = {
                  useListString: useListString
                }
                this.reqAddUseString(reqData);
              }
            });
      }
    },
    async reqAddUseString(data) {
      try {
        const res = await this.$api.updateUseList(data);
        this.useList = res.data.map((item, idx) => {
          return {
            no: idx + 1,
            value: item
          }
        });
        const useString =  res.data.join(',');
        this.$store.commit('centerUseList', useString);

        this.useUpdateFlag = false;
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqAddUseString'});
      }
    },

  },
}
</script>

<style scoped>
.updateTableCol {
  width: 50px;
  text-align: center;
  vertical-align: center;
  margin: 0;
  padding: 0;
}
</style>
